module.exports = __webpack_public_path__ + "static/img/minicon3.2a74c3b2.png";